// Function to calculate the UNIX timestamp for a specific time of day
export const convertToUnitTimestamp = (
  day: number,
  hour: number,
  minute: number
) => {
  const now = new Date()
  const expirationDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + day,
    hour,
    minute
  )

  // expirationDate.setHours(expirationDate.getHours() - 8);
  return Math.floor(expirationDate.getTime() / 1000)
}

// Set the expiration time for the cached data to 9 am

export const getDateDifference = (date: string | number | Date) => {
  //let diff = differenceInMinutes(new Date(), new Date(date));
  let diff = 59
  if (diff < 60) return diff + " minutes ago"

  diff = Math.ceil(diff / 60)
  if (diff < 24) return `${diff} hour${diff === 0 ? "" : "s"} ago`

  diff = Math.ceil(diff / 24)
  if (diff < 30) return `${diff} day${diff === 0 ? "" : "s"} ago`

  diff = Math.ceil(diff / 30)
  if (diff < 12) return `${diff} month${diff === 0 ? "" : "s"} ago`

  diff = diff / 12
  return `${diff.toFixed(1)} year${Math.ceil(diff) === 0 ? "" : "s"} ago`
}

export const sortBy = (key: any) => {
  return (a: any, b: any) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0)
}
export function formatPercentage(amount: number) {
  return Intl.NumberFormat("en-GB", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  }).format(amount)
}

export function formatCurrency(amount: number) {
  return (
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    }).format(amount) + "₮"
  )
}

export function formatCurrencyWithDecimals(
  amount: number,
  fractionDigits = 2,
) {
  return (
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(amount) + "₮"
  )
}

export function formatUSDCurrency(amount: number) {
  return (
    "$" +
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    }).format(amount)
  )
}

export function formatEURCurrency(amount: number) {
  return (
    "€" +
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    }).format(amount)
  )
}

export function formatCurrencyMNT(amount: number) {
  return (
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    }).format(amount) + " MNT"
  )
}

export function formatNumber(amount: number) {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
  }).format(amount)
}

export function setSearchParam(
  queryString: URLSearchParams,
  param: string,
  value: any
) {
  if (queryString.toString()) {
    return `?${queryString.toString()}&${param}=${value}`
  }
  return `?${param}=${value}`
}

export function sanitizeHtml(input: string): string {
  return input.replace(/<\/?[^>]+(>|$)/g, "")
}

export function graphqlHeader(session: any) {
  let header = {}
  return header
}

export function calculateTimeDifferenceInSeconds(
  timestamp1: number,
  timestamp2: number
): number {
  const timeDifferenceInMilliseconds = timestamp2 - timestamp1
  const timeDifferenceInSeconds = timeDifferenceInMilliseconds / 1000
  return timeDifferenceInSeconds
}

export function countdown() {
  return "1 udriin dotor"
}

export function replaceLastFourDigits(input: string): string {
  if (input.length >= 4) {
    const prefix = input.substring(0, input.length - 2)
    const asterisks = "*".repeat(2)
    return prefix + asterisks
  } else {
    // Handle the case where the input string is too short
    return input
  }
}

export function capitalizeFirstLetter(str: string): string {
  if (!str) return str // Handle empty strings
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function parseFormData(formData: FormData) {
  const formObject: Record<string, any> = {}
  formData.forEach((value, key) => {
    formObject[key] = value
  })
  return formObject
}

export function transliterate(text: string): string {
  const map: Record<string, string> = {
    а: "a",
    б: "b",
    в: "v",
    г: "g",
    д: "d",
    е: "e",
    ё: "yo",
    ж: "j",
    з: "z",
    и: "i",
    й: "y",
    к: "k",
    л: "l",
    м: "m",
    н: "n",
    о: "o",
    ө: "o",
    п: "p",
    р: "r",
    с: "s",
    т: "t",
    у: "u",
    ү: "u",
    ф: "f",
    х: "h",
    ц: "ts",
    ч: "ch",
    ш: "sh",
    щ: "sh",
    ъ: "",
    ы: "y",
    ь: "",
    э: "e",
    ю: "yu",
    я: "ya",
    " ": "", // remove spaces
  }

  const transliterated = text
    .toLowerCase()
    .split("")
    .map((char) => map[char] ?? char)
    .join("")

  // Then URL encode to make it safe for use in file names / URLs
  return encodeURIComponent(transliterated)
}

export function formatName(name: string) {
  if (!name) return ""
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
}

export function getBackgroundStyle(bg: string | undefined) {
  if (!bg) return {}

  const value = bg.trim()

  // If it's a gradient
  if (
    value.startsWith("linear-gradient") ||
    value.startsWith("radial-gradient")
  ) {
    // Remove optional "background:" prefix just in case
    const cleaned = value.replace(/^background\s*:\s*/, "")
    return { background: cleaned }
  }

  // Otherwise assume it's a plain color (hex, rgb, etc.)
  return { backgroundColor: value }
}
